<template>
  <svg class="sl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <path v-for="(path, index) in paths" :key="index" :d="path" />
  </svg>
</template>
<script>
const icons = {
  home: ['M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z'],
  grid: ['M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z'],
  game: ['M7 7h10c2 0 3 2 3.5 4l1 7c.3 2-1.5 3-3 1l-3-3h-7l-3 3c-1.5 2-3.3 1-3-1l1-7C4 9 5 7 7 7z', 'M6 11v4M4 13h4M16 12h.01M19 14h.01'],
  user: ['M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0', 'M4 21v-2a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v2'],
  arrow: ['m9 5 7 7-7 7'],
  settings: ['M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8', 'm9 3-1 3-3 1-2 3 2 2-1 3 2 3 3 1 1 2h4l1-2 3-1 2-3-1-3 2-2-2-3-3-1-1-3z'],
  lock: ['M6 10h12a1 1 0 0 1 1 1v9H5v-9a1 1 0 0 1 1-1', 'M8 10V7a4 4 0 1 1 8 0v3M12 14v3'],
  record: ['M6 3h12v18H6z', 'M9 7h6M9 11h6M9 15h4'],
  bank: ['m3 8 9-5 9 5H3M5 11v7M10 11v7M14 11v7M19 11v7M3 21h18'],
  wallet: ['M20 7V5H5a2 2 0 0 1 0-4h13', 'M3 3v16a2 2 0 0 0 2 2h15V7H5', 'M20 12h-5v5h5M16 14.5h.01'],
  coin: ['M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0', 'M15 8h-4a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4H9M12 6v12'],
  shield: ['m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6z', 'm8 12 3 3 5-6'],
  crown: ['m3 6 5 5 4-7 4 7 5-5-2 13H5z'],
  logout: ['M10 4H4v16h6M8 12h13m-4-4 4 4-4 4'],
  search: ['M18 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0', 'm15 15 6 6'],
  play: ['m9 5 11 7-11 7z'],
  spark: ['m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z'],
  heart: ['M20.5 5a5 5 0 0 0-7 0L12 6.5 10.5 5a5 5 0 0 0-7 7L12 21l8.5-9a5 5 0 0 0 0-7'],
};
export default {
  props: { name: { type: String, default: 'spark' } },
  computed: { paths() { return icons[this.name] || icons.spark } },
};
</script>
